import React from "react";

import { Show, SimpleShowLayout, TextField, BooleanField, ReferenceArrayField, SingleFieldList } from "react-admin";

const ShowUsers = () => {
  return (
    <Show title="Детайли за потребител">
      <SimpleShowLayout sx={{ padding: "2em" }}>
        <TextField
          label="№"
          source="id"
        />
        <TextField
          label="Име"
          source="first_name"
        />{" "}
        <TextField
          label="Фамилия"
          source="last_name"
        />{" "}
        <TextField
          label="E-мейл"
          source="email"
        />
        <TextField
          label="Парола"
          source="password"
        />
        <TextField
          label="Телефон"
          source="phone_number"
        />
        <BooleanField
          label="Лимитиран"
          source="is_limited_to_one_session"
        />
        <BooleanField
          label="Блокиран"
          source="is_blocked"
        />
        <BooleanField
          label="Администратор"
          source="is_administrator"
        />
        <ReferenceArrayField
          source="role_ids"
          reference={"users/roles"}
        >
          <SingleFieldList>
            <TextField
              source="name"
              label="Активни права"
            />
          </SingleFieldList>
        </ReferenceArrayField>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowUsers;
